import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { DefaultContainer } from '../../modal/detail-modal/default-container/default-container';
import { useLinksCard } from './links-card.controller';

export interface LinksCardProps {
    privacyDocumentFile?: { blob: Blob; url: string } | null;
}

export const LinksCard = (props: LinksCardProps) => {
    const viewProps = useLinksCard(props);
    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='profile.links-card.title'
                    defaultMessage='Links'
                    description='Title for the links card in profile page'
                />
            }
            content={
                <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                    <a
                        href={viewProps.privacyDocumentFile ? viewProps.privacyDocumentFile.url : 'https://telloport.com/privacy-policy/'}
                        target='_blank'
                        rel='noreferrer'
                        className='text-brand-primary hover:text-brand-secondary justify-start text-base font-medium'>
                        <FormattedMessage
                            id='profile.privacy-policy'
                            defaultMessage='Privacy policy'
                            description='Label for telloport privacy policy'
                        />
                    </a>
                    <a
                        target='_blank'
                        rel='noreferrer'
                        href='https://drive.google.com/file/d/1Gpt4N6kvRmvNlRDc6Q3LVMsBRdl5SrYj/view'
                        className='text-brand-primary hover:text-brand-secondary justify-start text-base font-medium'>
                        <FormattedMessage
                            id='eula.user-agreement'
                            defaultMessage='User agreement'
                        />
                    </a>
                    <Link
                        to='/release-notes'
                        className='text-brand-primary hover:text-brand-secondary justify-start text-base font-medium'>
                        <FormattedMessage
                            id='release-notes'
                            defaultMessage='Release notes'
                        />
                    </Link>
                </div>
            }
        />
    );
};
